import { createContext } from 'react';

import type { GroupSubscriptionData } from '@shared/dream-components';

/**
 * Exposes the dev-scenario-applied group list for the General tab's group/individual overlap
 * detection. Decoupled from `GroupSubscriptionsProvider` (which owns the raw groups + Groups-tab
 * logic): this layer just reads `groupSubscriptions` and runs them through `DevScenarioProvider`'s
 * `applyGroupScenario` (an identity passthrough in production where the scenario stays `'live'`).
 * Mounted below both providers so it can consume each.
 */
export type EffectiveGroupSubscriptionsContextType = {
  /** Dev-scenario-applied groups — what the General tab's overlap detection reads. */
  effectiveGroupSubscriptions: GroupSubscriptionData[];
};

export const EffectiveGroupSubscriptionsContext = createContext<EffectiveGroupSubscriptionsContextType | undefined>(
  undefined,
);
EffectiveGroupSubscriptionsContext.displayName = 'EffectiveGroupSubscriptionsContext';
